import React from "react";

export default function ShowDetailModal({ handleClose, detailData = null }) {
  return (
    <>
      <div className="justify-center relative flex mx-auto overflow-x-auto overflow-y-auto inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 max-w-3xl justify-center">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">Detail</h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={() => handleClose()}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div className="relative left-2 p-6 flex-auto">
              {detailData && (
                <>
                  <p className="my-2 leading-relaxed text-sm font-base p-5">
                    Created By{" "}
                    <b>
                      {detailData.created_by
                        ? detailData.created_by
                        : detailData.nama_user
                        ? detailData.nama_user
                        : "..."}
                    </b>{" "}
                    At <b>{detailData.created_at}</b>
                  </p>
                  {detailData.updated_at && (
                    <p className="my-2 leading-relaxed text-sm font-base p-5">
                      Updated At <b>{detailData.updated_at}</b>
                    </p>
                  )}
                </>
              )}
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              <button
                className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={() => handleClose()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
}
